import { createGlobalStyle } from 'styled-components';

export default createGlobalStyle`
  * {
    margin: 0;
    padding: 0;
    box-sizing: border-box;
    scroll-behavior: smooth;
  }

  body {
    margin: 0 !important;
    padding: 0 !important;
    box-sizing: border-box !important;
  }
`;
